var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "welcome-messages" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.welcomeMessages") }],
            select: true,
          },
        },
        [
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.startFilter") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.welcome-message-form",
                  modifiers: { "welcome-message-form": true },
                },
              ],
              staticClass: "actionButtonBreadcrumb",
              on: {
                click: function ($event) {
                  _vm.editMode = false
                },
              },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.newWelcomeMessages")) +
                  "\n        "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c("a-table", {
            staticClass: "custom-table2",
            attrs: {
              columns: _vm.cols(),
              dataSource: _vm.getFilteredRows(),
              loading: _vm.isBusy,
              locale: {
                emptyText: _vm.$t("message.noWelcomeMessageFound"),
              },
              pagination: false,
              rowKey: "_id",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "subjectSlot",
                  fn: function (data, item) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.subjects().find(function (s) {
                              return (
                                s.value ===
                                _vm.read(
                                  item,
                                  "languageContent." +
                                    _vm.$i18n.locale +
                                    ".name"
                                )
                              )
                            }).text
                          ) +
                          "\n            "
                      ),
                    ])
                  },
                },
                {
                  key: "contentSlot",
                  fn: function (data, item) {
                    return _c("div", {}, [_vm._v(_vm._s(_vm.domDecoder(data)))])
                  },
                },
                {
                  key: "actionsSlot",
                  fn: function (data, item) {
                    return _c(
                      "div",
                      { key: "actionsSlot" + _vm.$i18n.locale },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex w-100 justify-content-start" },
                          [
                            _c(
                              "a-button",
                              {
                                staticClass:
                                  "actionButton d-flex align-items-center",
                                attrs: {
                                  content: _vm.$t("message.editThisItem"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(item._id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "16px",
                                      display: "block",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("message.edit")))]
                                ),
                                _vm._v(" "),
                                _c("ActionEdit"),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass:
                                  "actionButton d-flex align-items-center",
                                attrs: {
                                  content: _vm.$t("message.removeThisItem"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(item._id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "16px",
                                      display: "block",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.deleteField"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("ActionDelete"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  },
                },
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3 d-flex justify-content-end" },
            [
              _c("Pagination", {
                attrs: {
                  "page-change": _vm.pageChange,
                  "page-sizes": _vm.pageSizes,
                  total: _vm.welcomeMessages.total,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.welcome-message-form",
              modifiers: { "welcome-message-form": true },
            },
          ],
          staticClass: "fab d-flex justify-content-center align-items-center",
          on: {
            click: function ($event) {
              _vm.editMode = false
            },
          },
        },
        [_c("md-icon", {}, [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "welcome-message-form",
            title: _vm.editMode
              ? _vm.$t("message.updateWelcomeMessageForm")
              : _vm.$t("message.newWelcomeMessageForm"),
            centered: "",
            "hide-footer": "",
            size: "lg",
          },
          on: { hidden: _vm.reset },
        },
        [
          _vm.$validator.errors.items.length && _vm.submitClicked
            ? _c(
                "a-alert",
                {
                  staticClass: "mb-2",
                  attrs: {
                    message: _vm.$t("message.error"),
                    showIcon: "",
                    type: "error",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    _vm._l(_vm.$validator.errors.items, function (err, index) {
                      return _c("div", { key: "err-" + index }, [
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(err.msg) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form",
            {
              staticClass: "d-flex flex-column justify-content-center",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSave.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("message.title"),
                            "label-for": "display-name-input",
                          },
                        },
                        [
                          _c("b-form-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              name: _vm.$t("message.title"),
                              options: _vm.subjects(),
                            },
                            model: {
                              value: _vm.selectedWMType,
                              callback: function ($$v) {
                                _vm.selectedWMType = $$v
                              },
                              expression: "selectedWMType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { card: "" } },
                        _vm._l(_vm.languages, function (language, index) {
                          return _c(
                            "b-tab",
                            {
                              key: "lang-" + index,
                              attrs: { title: language.name },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "content-input-group",
                                            label: _vm.$t("message.content"),
                                            "label-for": "content-input",
                                          },
                                        },
                                        [
                                          _c("wysiwyg", {
                                            attrs: {
                                              id: "content-input",
                                              placeholder: _vm.$t(
                                                "message.welcomeMessageContent"
                                              ),
                                              "v-validate":
                                                language.code ===
                                                _vm.defaultLang
                                                  ? "required"
                                                  : "",
                                            },
                                            model: {
                                              value:
                                                _vm.welcomeMessage
                                                  .languageContent[
                                                  language.code
                                                ].content,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.welcomeMessage
                                                    .languageContent[
                                                    language.code
                                                  ],
                                                  "content",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "welcomeMessage.languageContent[language.code].content",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            disabled: _vm.loading,
                                            type: "submit",
                                            variant: "primary",
                                          },
                                        },
                                        [
                                          !_vm.loading
                                            ? [
                                                !_vm.editMode
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.save"
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.update"
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]),
                                              ]
                                            : [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "spinner",
                                                    spin: "",
                                                  },
                                                }),
                                              ],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          on: {
                                            click: function () {
                                              return _vm.$bvModal.hide(
                                                "welcome-message-form"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t("message.cancel")
                                                ) +
                                                "\n                                        "
                                            ),
                                          ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }